<template lang="pug">
.pointer-events-none(:style='rotation')
  div(:style='translation')
    div(:style='inverseRotation')
      .ding
        slot
</template>

<script>
export default {
  name: 'Rotator',
  props: {
    w: { type: [String, Number], required: false, default: 0 },
    x: { type: [String, Number], required: false, default: 0 },
    y: { type: [String, Number], required: false, default: 0 },
    duration: { type: [String], required: false, default: '5s' },
    reverse: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    translation() {
      return {
        transform: `translateY(${this.y}px) translateX(${this.x}px)`,
      }
    },
    rotation() {
      return {
        ...this.styleObject,
        'animation-direction': this.reverse ? 'reverse' : 'normal',
      }
    },
    inverseRotation() {
      return {
        ...this.styleObject,
        'animation-direction': this.reverse ? 'normal' : 'reverse',
      }
    },
    styleObject() {
      return {
        'animation-name': 'infiniteRotate',
        'animation-timing-function': 'linear',
        'animation-iteration-count': 'infinite',
        'animation-duration': this.duration,
      }
    },
  },
}
</script>

<style lang="stylus">
@keyframes infiniteRotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.ding{
  // border 1px solid red
  transform: translate(-50%, -50%)
}
</style>
